export class CountResult {
    Aggregations: Record<string, unknown>;
    Total: number;
}

export type StatusAggregationItem = {
    Value: number;
    Key: number;
    Total: number;
};

export type NestedAggregationItem = {
    Value: number;
    Key: number | string;
    Date: string;
    KeyAsString: string;
    Total: number;
    Aggregations: { [key: string]: { Items: NestedAggregationItem[]; Value: number } };
};
